import { render, staticRenderFns } from "./CookieSelector.vue?vue&type=template&id=f3265512&scoped=true"
import script from "./CookieSelector.vue?vue&type=script&lang=js"
export * from "./CookieSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3265512",
  null
  
)

export default component.exports